import React from 'react';

const FormContainerMax = (props) => {
    return (
        <div className="demo-section k-content dynmicwhitecntr DynamicFieldsMax">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"> 
                <div className="row example-wrapper">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="card-block">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default FormContainerMax;